import {GeneralTypeModel} from '../models/general-type.model';

export enum SourceReviewFrequencyWeightTypeEnum {
  Never = 1,
  Less = 2,
  Medium = 3,
  More = 4,
  High = 5
}

export function sourceReviewFrequencyWeightTypeEnumToGeneralTypeModel(type: SourceReviewFrequencyWeightTypeEnum | null): GeneralTypeModel {
  switch (type) {
    case SourceReviewFrequencyWeightTypeEnum.Never:
      return { name: 'Never', color: '#aa0000'};
    case SourceReviewFrequencyWeightTypeEnum.Less:
      return { name: 'Less', color: '#aab900'};
    case SourceReviewFrequencyWeightTypeEnum.Medium:
      return { name: 'Medium', color: '#00bc5e'};
    case SourceReviewFrequencyWeightTypeEnum.More:
      return { name: 'More', color: '#0090bc'};
    case SourceReviewFrequencyWeightTypeEnum.High:
      return { name: 'High', color: '#4a1de1'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
